import React from 'react';
import * as Sentry from '@sentry/react';
import { ErrorDialog } from '../error-dialog';
import PropTypes from 'prop-types';

export default function ErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary
      fallback={
        <ErrorDialog
          open
          errors={[
            'There was an error on our app, we are sending the details to the dev team.',
            'Unsaved changes will need to be made again.',
            'Feel free to add some feedback.'
          ]}
          title="Application Error"
          label="Report Feedback"
        />
      }
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}

ErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired
};
